<div class="modal-header">
  <h4 class="modal-title page-title">Confirmation</h4>
</div>
<div class="modal-body nav-white-box">
  <div class="container-fluid">
    <p>{{confMessage}}</p>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-ornge" (click)="this.activeModal.close(true)" >Confirm</button>
  <button type="button" class="btn btn-gray" (click)="this.activeModal.close(false)">Cancel</button>
</div>